import { render, staticRenderFns } from "./TopFundraisers.vue?vue&type=template&id=53b4a740&"
import script from "./TopFundraisers.vue?vue&type=script&lang=js&"
export * from "./TopFundraisers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports